<ng-template #template>
  <div class="p-lg-0 card-spacing" [ngClass]="'col-lg-' + width">
    <div class="card card-comb-right h-100">
      <div class="card-body">
        <h2>{{ data?.title }}</h2>
        <h3 class="title-ranking-indices">{{ data?.rankingTitle }}</h3>
        <div class="table-responsive">
          <table
            class="table table-borderless h3-eq ranking"
            style="line-height: 1.5"
          >
            <tbody>
              <tr
                *ngFor="let entry of data?.rankingEntries"
                [class.table-active]="entry.currentTeam"
              >
                <td>
                  <img
                    src="img/arrow-up.svg"
                    *ngIf="entry.trend == '+' && !highContrast"
                    placement="top"
                    ngbTooltip="{{ entry.variation }}"
                    tooltipClass="green-tooltip"
                  />
                  <img
                    src="img/arrow-up-red.svg"
                    *ngIf="entry.trend == '+r' && !highContrast"
                    placement="top"
                    ngbTooltip="{{ entry.variation }}"
                    tooltipClass="red-tooltip"
                  />
                  <img
                    src="img/arrow-down.svg"
                    *ngIf="entry.trend == '-' && !highContrast"
                    placement="top"
                    ngbTooltip="{{ entry.variation }}"
                    tooltipClass="red-tooltip"
                  />
                  <img
                    src="img/arrow-down-green.svg"
                    *ngIf="entry.trend == '-g' && !highContrast"
                    placement="top"
                    ngbTooltip="{{ entry.variation }}"
                    tooltipClass="green-tooltip"
                  />

                  <img
                    src="img/arrow-up-hc.svg"
                    *ngIf="entry.trend == '+' && highContrast"
                    placement="top"
                    ngbTooltip="{{ entry.variation }}"
                    tooltipClass="green-tooltip"
                  />
                  <img
                    src="img/arrow-up-red-hc.svg"
                    *ngIf="entry.trend == '+r' && highContrast"
                    placement="top"
                    ngbTooltip="{{ entry.variation }}"
                    tooltipClass="red-tooltip"
                  />
                  <img
                    src="img/arrow-down-hc.svg"
                    *ngIf="entry.trend == '-' && highContrast"
                    placement="top"
                    ngbTooltip="{{ entry.variation }}"
                    tooltipClass="red-tooltip"
                  />
                  <img
                    src="img/arrow-down-green-hc.svg"
                    *ngIf="entry.trend == '-g' && highContrast"
                    placement="top"
                    ngbTooltip="{{ entry.variation }}"
                    tooltipClass="green-tooltip"
                  />

                  <img src="img/stagne.svg" *ngIf="entry.trend == '='" />
                </td>
                <td>{{ entry.position }}</td>
                <th scope="row">{{ entry.teamName }}</th>
                <td class="text-right">{{ entry.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3
          class="title-ranking-indices"
          *ngIf="data?.businessIndexes.length > 0"
        >
          {{ data?.businessIndexTitle }}
        </h3>
        <div class="table-responsive" *ngIf="data?.businessIndexes.length > 0">
          <table
            class="table table-borderless h3-eq table-bullets"
            style="line-height: 1.5"
          >
            <tbody>
              <tr *ngFor="let entry of data?.businessIndexes">
                <th scope="row" class="{{ cssColor }}"></th>
                <td>
                  <a
                    (click)="zoom(entry.zoomInfo)"
                    href="javascript:void(0);"
                    style="cursor: pointer"
                    >{{ entry.name }}</a
                  >
                </td>
                <td class="text-right">{{ entry.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-template>
